import React, { useState } from "react";
import styles from "./CookieConsentBanner.module.scss";
import classNames from "classnames/bind";
import useConsentStore from "../../stores/Consent/useConsentStore";

const cx = classNames.bind(styles);

/**
 * CookieConsentBanner
 * Hiển thị khi người dùng chưa chọn consent (status === "unknown").
 * Cho phép đồng ý hoặc từ chối lưu cookie/localStorage.
 */
const CookieConsentBanner = () => {
  const { status, accept, decline } = useConsentStore();
  const [isExiting, setIsExiting] = useState(false);

  // Không render nếu đã có quyết định hoặc đang exit animation
  if (status !== "unknown") return null;

  const handleAccept = () => {
    setIsExiting(true);
    setTimeout(() => {
      accept();
    }, 300);
  };

  const handleDecline = () => {
    setIsExiting(true);
    setTimeout(() => {
      decline();
    }, 300);
  };

  return (
    <div className={cx("banner", { "banner--exit": isExiting })}>
      <div className={cx("banner__inner")}>
        {/* Icon */}
        <div className={cx("banner__icon")}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
              fill="currentColor"
            />
          </svg>
        </div>

        {/* Text */}
        <div className={cx("banner__text")}>
          <p className={cx("banner__message")}>
            Chúng tôi sử dụng cookie để lưu giỏ hàng, danh sách yêu thích và
            cải thiện trải nghiệm mua sắm của bạn. Bạn có thể đồng ý hoặc từ
            chối.
          </p>
        </div>

        {/* Actions */}
        <div className={cx("banner__actions")}>
          <button
            id="cookie-consent-decline"
            className={cx("banner__btn", "banner__btn--secondary")}
            onClick={handleDecline}
            aria-label="Từ chối cookie"
          >
            Từ chối
          </button>
          <button
            id="cookie-consent-accept"
            className={cx("banner__btn", "banner__btn--primary")}
            onClick={handleAccept}
            aria-label="Đồng ý sử dụng cookie"
          >
            Đồng ý
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
